import { Select, Spin } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import DebounceSelect from "@/component/DebounceSelect";
import { request } from '@/utils/useRequest';
import { useCacheStore } from "@/store/useCacheStore";

const UserSelect = ({ value, onChange, multiple, disabled, roleName, initial }) => {

    const getCache = useCacheStore.use.get();
    const setCache = useCacheStore.use.set();

    const handleChange = value => {
        if (onChange) onChange(value);
    };

    const fetchUserList = useCallback(async (username) => {
        console.log('fetching user', username);
        const result = await request('/api/v2/private/user/list', "POST", "json", {
            filters: {
                keywords: username,
                roleName: roleName ? roleName.split(",") : undefined,
            },
            pagination: {
                current: 1,
                pageSize: 30,
            }
        });
        if (result.success) {
            return result.data.map(user => ({
                label: `${user.Name}(${user.Phone ?? '-'})`,
                value: user.Id,
                Username: user.Username,
                Phone: user.Phone,
                Nickname: user.Nickname,
                Id: user.Id,
            }));
        };
        return [];
    }, [roleName]);

    const [options, setOptions] = useState([]);
    useEffect(() => {
        if (initial === 'true') {
            const cacheKey = `user-options-${roleName}`;
            if (!!roleName) {
                const result = getCache(cacheKey);
                if (!!result) {
                    setOptions(result);
                    return;
                }
            }

            fetchUserList('').then(data => {
                setOptions(data);
                if (!!roleName) setCache(cacheKey, data);
            });
        }
    }, [initial]);

    // 初始化数据，则直接使用Select
    if (initial === 'true') {
        return (
            <Select
                style={{
                    width: '100%',
                }}
                showSearch
                mode={multiple === 'true' ? 'multiple' : ''}
                disabled={disabled === 'true'}
                value={value}
                defaultValue={value}
                placeholder="输入名称或电话查询"
                onChange={handleChange}
                options={options}
                notFoundContent={<Spin spinning>请稍候...</Spin>}
                optionFilterProp='children'
                filterOption={(inputValue, option) => {
                    const { Phone, Nickname, UserName } = option;
                    return Phone?.includes(inputValue) || Nickname?.includes(inputValue) || UserName?.index(inputValue);
                }}
            />
        );
    }

    return (
        <DebounceSelect
            showSearch
            mode={multiple === 'true' ? 'multiple' : ''}
            disabled={disabled === 'true'}
            value={value}
            defaultValue={value}
            placeholder="输入名称或电话查询"
            fetchOptions={fetchUserList}
            onChange={handleChange}
            style={{
                width: '100%',
            }}
        />
    );
}

export default UserSelect;